import styled from "styled-components";

export const PickerContainer = styled.div`
	margin-bottom: 16px;
	padding: 20px;
	border: 1px dashed #d9d9d9;
	border-radius: 4px;
	text-align: center;
	width: 100%;
`;

export const SelectedFiles = styled.ul`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
	gap: 16px;
	margin: 20px 0 0;
	padding: 0;
	list-style: none;
	text-align: left;
`;

export const SelectedFile = styled.li`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 0;
`;

export const Thumbnail = styled.div`
	position: relative;
	overflow: hidden;
	background: #f2f6fa;
	border-radius: 4px;

	&::before {
		display: block;
		padding-top: 100%;
		content: "";
	}

	img,
	video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

// The play mark of a video thumbnail.
export const VideoBadge = styled.span`
	position: absolute;
	top: 50%;
	left: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	color: #fff;
	font-size: 20px;
	background: rgba(0, 0, 0, 0.5);
	border-radius: 50%;
	transform: translate(-50%, -50%);
`;

export const FileName = styled.span`
	overflow: hidden;
	color: #2e333e;
	font-size: 13px;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const FileSize = styled.span`
	color: #8c8c8c;
	font-size: 12px;
`;
